module.exports = __webpack_public_path__ + "right_users-716e537486b05ef780f750392fc65bfe.png";